<template>
  <div class="space-y-6">
    <div class="space-y-2">
      <h2 class="text-lg font-bold">Contratação de estratégia em período de teste</h2>
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Para contratar esta estratégia é necessário assinar um dos planos do parceiro
        <span class="text-ontick-carbon-900 font-semibold dark:text-gray-300">
          {{ strategyInfo.strategy_developer }}
        </span>
      </p>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="isLoading" class="flex h-64 w-full items-center justify-center">
        <div>
          <i v-html="$icons.loading" class="text-ontick-blue-600"> </i>
          <span class="sr-only"> Carregando </span>
        </div>
      </div>
      <div v-else-if="planData.length === 0" class="flex h-64 w-full items-center justify-center">
        <p class="text-lg font-bold">Dados não encontrados</p>
      </div>
      <div class="space-y-2" v-else>
        <p>Planos sugeridos</p>
        <div class="flex flex-col items-end gap-2">
          <div
            v-for="(plan, index) in planData"
            :key="plan.plan_name"
            role="button"
            class="bg-ontick-steel-500 flex w-full items-center gap-4 rounded-md border-2 bg-opacity-50 py-2 px-4 filter transition-all ease-in-out hover:brightness-110"
            :class="index === selectedPlan ? 'border-ontick-blue-600' : 'border-ontick-steel-500'"
            @click="selectedPlan = index"
          >
            <div class="flex items-center justify-center">
              <div
                class="flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full border-2"
                :class="selectedPlan === index ? 'border-ontick-blue-600' : 'border-gray-400'"
              >
                <div
                  v-if="selectedPlan === index"
                  class="bg-ontick-blue-600 h-[14px] w-[14px] min-w-[14px] rounded-full"
                ></div>
              </div>
            </div>
            <div class="space-y-1">
              <div class="flex items-center gap-4">
                <span class="font-semibold uppercase">
                  {{ plan.plan_name }}
                </span>
                <div
                  v-if="index === planData.length - 1"
                  class="bg-ontick-green-600 rounded-full px-2 py-1 text-xs text-white"
                >
                  Mais indicado
                </div>
              </div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{ plan.extension_plan_desc }}
              </p>
            </div>
            <div class="flex items-center whitespace-nowrap text-sm">
              <span class="font-semibold dark:text-white">
                {{ plan.extension_price | currency }}
              </span>
              <span class="text-xs text-gray-500 dark:text-gray-400">
                /{{ recurrence(plan.billing_frequency).full }}
              </span>
            </div>
          </div>
          <!-- <a href="#" class="text-ontick-blue-600 self-end text-xs underline">
          Ver todos os planos
        </a> -->
        </div>
      </div>
    </transition>
    <div>
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Oferecemos uma avaliação gratuita de
        <span class="text-ontick-carbon-900 font-semibold dark:text-gray-300">7 dias</span>. Cancele antes do dia
        <span class="text-ontick-carbon-900 font-semibold dark:text-gray-300">
          {{ moment().add(7, "days").format("DD/MM/YYYY") }}
        </span>
        para evitar a cobrança automática.
      </p>
    </div>
    <ontick-button
      class="w-full"
      :disabled="!planData.length"
      @click.native="
        $router.push({
          name: 'Pagamentos',
          query: {
            type: 'extensions',
            extension_id: planData[selectedPlan].extension_id,
          },
        })
      "
    >
      <span class="text-xs"> Confirmar dados de pagamento </span>
    </ontick-button>
  </div>
</template>

<script>
export default {
  props: {
    strategyInfo: {
      type: Object,
    },
  },

  data() {
    return {
      selectedPlan: null,
      planData: [],
      isLoading: false,
    };
  },

  methods: {
    recurrence(recurrence) {
      switch (recurrence) {
        case "MONTH":
          return {
            full: "mês",
            relative: "mensal",
          };
        case "2_MONTH":
          return {
            full: "bimestre",
            relative: "bimestral",
          };
        case "3_MONTH":
          return {
            full: "trimestre",
            relative: "trimestral",
          };
        case "6_MONTH":
          return {
            full: "semestre",
            relative: "semestral",
          };
        case "YEAR":
          return {
            full: "ano",
            relative: "anual",
          };
        default:
          return {
            full: "mês",
            relative: "mensal",
          };
      }
    },
    getProductPlans({ product_id, strategy_id }) {
      this.isLoading = true;
      this.$api
        .get(this.$endpoint.GET_RANKING_PRODUCT_PLANS(product_id, strategy_id))
        .then((res) => {
          // console.log(res);
          this.planData = res.data;
          this.selectedPlan = this.planData.length - 1;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getProductPlans(this.strategyInfo);
  },
};
</script>

<style scoped lang="scss">
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
